import React, { useEffect } from 'react';

import useSelector, { useSteps } from 'components/Booking-new/hooks';

import stepsList from 'components/Booking-new/modules/Steps';
import Info from 'components/common/Info';

const StepsProvider = () => {
  const { activeStep, goToNextStep, goToPrevStep, goToStep, goToStepType, isNextStep, isPrevStep, allStepsCount } =
    useSteps();

  const {
    results: { isError, errorData, userData },
  } = useSelector(state => ({
    isError: state.isError,
    errorData: state.config.errorPage,
    userData: state.userData,
  }));

  const activeStepType = activeStep?.type;

  const StepComponent = stepsList[activeStepType];
  const shouldRenderError = !StepComponent || isError || allStepsCount === 0;
  const stepData = userData?.[activeStepType];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  if (shouldRenderError) return <Info data={errorData} />;

  const componentProps = {
    data: { ...activeStep.data },
    name: activeStepType,
    navigation: {
      goToNextStep,
      goToPrevStep,
      goToStepType,
      goToStep,
      isNextStep,
      isPrevStep,
    },
    userData: stepData,
  };

  return (
    <>
      <StepComponent variant={activeStep.variant} {...componentProps} />
    </>
  );
};

export default StepsProvider;
